export function formatarDataHora(dateString, metodo = 'dataHota') {
    // Cria um objeto Date a partir da string ISO 8601
    const date = new Date(dateString);

    // Extrai os componentes da data
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Mês é zero-based
    const year = date.getFullYear();

    // Extrai os componentes da hora
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    // Formata a data e a hora em um formato amigável
    const friendlyDate = `${day}/${month}/${year} ${hours}:${minutes}`;

    if(metodo === 'data') {
        return `${day}/${month}/${year}`
    }

    if(metodo === 'hora') {
        return `${hours}:${minutes}`
    }

    if(metodo === 'dataHota') {
        return `${day}/${month}/${year} ${hours}:${minutes}`
    }
}